import React from 'react';
import './GeneralDocs.css'; 
import ChangeDetectorBlinks from '../assets/change_detector.png';


const Blinks = () => {
  return (
    <div className="docs-page-container">
      <h1>Blinks Detector</h1>
      <p>
        The Blinks Detector lets you control your computer using only blinks. To enable it, go to the configuration and click on change detector:
      </p>
      <img src={ChangeDetectorBlinks} alt="change detector to blinks" className="mode-image" />

      <h2>How it works?</h2>
      <p>
        The Blink Detector supports two different types of input: a single blink and a double blink.
        To detect blinks, FaceLead measures the distance between your eyelids to consider if the eyes are open or closed. 
      </p>
      <p>
        The detector's accuracy may vary depending on your eye shape and the speed of your blinks and double blinks.
        You can adjust the threshold to consider that the eyes are closed and the speed of the blinks in the Configuration.
      </p>
    </div>
  );
};

export default Blinks;
